import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import TodoDashboard from "../Components/TodoDashboard/main";
// import { fetchTodosPageData } from "../Redux/todos/actions";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
// import { useSelector } from "react-redux";
import { useTodoList } from "../Components/TodoDashboard/hook/useTodoList";

const ToDoPage = () => {
  const dispatch = useDispatch();

  // tabs/pages/client still come from Redux; the LIST does not.
  // const todoTabs = useSelector((state) => state.todos?.todoTabs);
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 3).then((data) => setPageObject(data));
    }
  }, [caseId, pageObject]);

  // still needed for todoTabs / client / pages — NOT for the list
  // useEffect(() => {
  //   fetchTodosPageData(dispatch);
  // }, [dispatch]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    fetchShakespeareStatus(caseId, 3, dispatch);
  }, [caseId, dispatch]);

  useEffect(() => {
    const preferences = localStorage.getItem("userPreferences");
    const preferencesObj = preferences ? JSON.parse(preferences) : null;
    setSideBarCollapsed(preferencesObj?.SidebarView);
  }, []);
  const [activeTab, setActiveTab] = useState("all");

  const { todos, todoTabs, loading, pageNo, hasNext, hasPrev, goNext, goPrev, refetch } =
    useTodoList(activeTab);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <div className="top-panel-wrapper" />
          <NavBar flaggedPageName="3" />
          <div className="main-content cost-tb" style={{ paddingTop: "165px" }}>
            <TodoDashboard
              pageObj={pageObject}
              todos={todos}
              todoTabs={todoTabs}
              loading={loading}
              pageNo={pageNo}
              hasNext={hasNext}
              hasPrev={hasPrev}
              goNext={goNext}
              goPrev={goPrev}
              activeTab={activeTab}
              refetch={refetch}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ToDoPage;
